export default {
      id: "edit_details-usage",
      viewBox: "0 0 24 17",
      url: __webpack_public_path__ + "img/icons.svg#edit_details",
      toString: function () {
        return this.url;
      }
    }